import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Config from "Config";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { utils, writeFile } from "xlsx";
import { send } from "../../SendRequest";
import { isNotEmpty } from "../../Utils";

const useStyles = makeStyles({
    failOrg: {
        color: "red",
        marginBottom: "10px",
        borderBottom: "1px solid #c5c3c3",
        paddingBottom: "5px",
    },
    noneOrg: {
        textAlign: "center",
        padding: "80px !important",
        marginBottom: "15px",
        // borderBottom: "1px solid black",
    },
    currnetOrg: {
        padding: "10px 0",
        marginBottom: "20px",
        // borderBottom: "1px solid black",
    },
    successOrg: {
        marginBottom: "8px",
        borderBottom: "1px solid #c5c3c3",
        paddingBottom: "8px",
    },
});

function Form104ApplicationSchoolList({ defaultValues, setValue }) {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const classes = useStyles();
    const initOrgList = defaultValues?.applicationSchoolList;
    const [orgList, setOrgList] = useState([]);
    const [successOrgList, setSuccessOrgList] = useState(initOrgList);
    const [uploadOrgFailOpen, setUploadOrgFailOpen] = useState(false);
    const [uploadFileFormatErrorOpen, setUploadFileFormatErrorOpen] =
        useState(false);

    const uploadFile = (file) => {
        const formData = new FormData();
        formData.append("schoolExcel", file);
        const option = {
            url: `${Config.CONTENT_PATH}/form104/uploadSchoolExcelData`,
            method: "POST",
            body: formData,
        };
        return dispatch(send("SUBMIT_ATTACHMENT", option))
            .then((response) => response.json())
            .then((data) => {
                if (data?.success === true) {
                    const successList = data?.data;
                    setSuccessOrgList(successList);
                    setValue("applicationSchoolList", successList);
                }
                if (data?.success === false && data?.code === "9005") {
                    setUploadOrgFailOpen(true);
                }
                if (data?.success === false && data?.code === "9004") {
                    setUploadFileFormatErrorOpen(true);
                }
            });
    };

    const readUploadFile = (event) => {
        event.preventDefault();
        if (event.target?.files?.length > 0) {
            try {
                const file = event.target.files[0];
                if (!file) {
                    return;
                }
                uploadFile(file);
            } catch (error) {
                console.log("upload excel error:" + error);
                setUploadFileFormatErrorOpen(true);
            }
            event.target.value = "";
        }
    };

    useEffect(() => {
        const option = {
            url: `${Config.CONTENT_PATH}/clo/getAllScmInfoDistrictSchoolNumber`,
        };
        dispatch(send("GET", option))
            .then((response) => response.json())
            .then((data) => {
                if (data?.success === true) {
                    setOrgList(data?.data);
                }
            });
    }, []);

    const handleSavedClose = () => {
        setUploadOrgFailOpen(false);
    };

    const downloadExcel = () => {
        let sheetData = [["schoolName", "schoolNumber"]];
        /*if (isNotEmpty(successOrgList)) {
            sheetData = successOrgList?.map((org) => {
                return [org?.name];
            });
        } else {*/
        sheetData = [
            ...sheetData,
            ...orgList?.map((org) => {
                return [org?.schoolName, org?.schoolNumber];
            }),
        ];
        //}
        const jsonWorkSheet = utils.aoa_to_sheet(sheetData);
        const workBook = {
            SheetNames: ["School"],
            Sheets: {
                ["School"]: jsonWorkSheet,
            },
        };
        const today = moment().format("yyyy_MM_DD");
        return writeFile(workBook, `School_${today}.xlsx`);
    };

    function uploadFileFormatErrorDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle id="simple-dialog-title">
                        {t("common.uploadFile")}
                    </DialogTitle>
                    <DialogContent>
                        {t("common.portal.uploadExcelFormatFail")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={() => {
                                setUploadFileFormatErrorOpen(false);
                            }}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    function FailUploadDialog(open) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle id="simple-dialog-title">
                        {t("common.uploadFile")}
                    </DialogTitle>
                    <DialogContent>
                        {t("common.portal.uploadExcelSchollNotMatchingFail")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={handleSavedClose}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    return (
        <Paper style={{ padding: "10px" }}>
            <Grid container spacing={5} alignItems="center">
                <Grid
                    item
                    xs={12}
                    className={
                        isNotEmpty(successOrgList)
                            ? classes.currnetOrg
                            : classes.noneOrg
                    }
                >
                    {isNotEmpty(successOrgList) ? (
                        <Box>
                            <TableContainer
                                style={{
                                    maxHeight: "300px",
                                    maxWidth: "500px",
                                    overflow: "auto",
                                }}
                            >
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                {t(
                                                    "common.portal.applicationSchool"
                                                )}
                                            </TableCell>
                                            <TableCell width="30%">
                                                {t(
                                                    "common.portal.applicationSchoolNumber"
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {successOrgList.map((org) => (
                                            <TableRow key={org.id}>
                                                <TableCell
                                                    dangerouslySetInnerHTML={{
                                                        __html: org?.schoolName,
                                                    }}
                                                    style={{
                                                        maxWidth: "250px",
                                                    }}
                                                ></TableCell>
                                                <TableCell>
                                                    {org?.schoolNumber}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    ) : (
                        t("common.portal.noneSchool")
                    )}
                </Grid>
                <Grid
                    item
                    xs={6}
                    style={{
                        textAlign: "center",
                        borderRight: "1px solid black",
                    }}
                >
                    <Box mb={4}>
                        <Typography>
                            {t("common.portal.downloadCurrnetSchool")}
                        </Typography>
                    </Box>
                    <Box>
                        <Button
                            variant="outlined"
                            component="label"
                            onClick={downloadExcel}
                        >
                            {t("common.download")}
                        </Button>
                    </Box>
                </Grid>
                <Grid item xs={6} style={{ textAlign: "center" }}>
                    <Box mb={4}>
                        <Typography>
                            {t("CCCUpdatePage.uploadExcelFile")}
                        </Typography>
                    </Box>
                    <Box>
                        <Button variant="outlined" component="label">
                            {t("common.fileUploadMsg")}
                            <input
                                hidden
                                accept=".xls,.xlsx"
                                type="file"
                                onChange={readUploadFile}
                            />
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            {uploadOrgFailOpen && FailUploadDialog(uploadOrgFailOpen)}
            {uploadFileFormatErrorOpen &&
                uploadFileFormatErrorDialog(uploadFileFormatErrorOpen)}
        </Paper>
    );
}

export default Form104ApplicationSchoolList;
